export const TASK_STATUS = {
  ONGOING: 'ongoing',
  PENDING: 'pending',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
  RETURNED_FOR_REWORK: 'returned_for_rework',
  SUBMITTED_FOR_REVIEW: 'submitted_for_review',
};